import { styled, Skeleton as UiSkeleton, Typography } from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)(() => ({
    width: 100,
}))

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["surfaces/surface-error"].main,
}))
